/* eslint-disable react/function-component-definition */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect, useState, Suspense } from "react";
import { Provider, useSelector } from "react-redux";
import { MuxProvider, Progress } from "@manulife/mux";
import store from "./store";

// Font declarations with font-display: swap - critical for LCP
import "./fonts.css";
// Global app styles only
import "./App.global.css";

// Performance: Lazy load Routes component
const Routes = React.lazy(() => import("./components/Routes"));

// Defer MUX CSS - reduce unused CSS blocking FCP/LCP (33KB)
if (typeof window !== "undefined") {
  // eslint-disable-next-line import/no-unresolved
  import("@manulife/mux/styles/index.css");
}

const App = () => {
  return (
    <Provider store={store}>
      <AppContainer />
    </Provider>
  );
};

function AppContainer() {
  const langVal = localStorage.getItem("langval");
  const language = useSelector(state => state.pageLoad.language);
  const [localization, setLocalization] = useState(langVal);
  useEffect(() => {
    setLocalization(langVal);
  }, [language]);
  return (
    <MuxProvider langProvider={{ lang: localization }} data-mux-theme="ca">
      <Suspense
        fallback={
          <Progress
            style={{ marginTop: "15%" }}
            className="centerPos"
            variant={Progress.VARIANT.STYLIZED_M}
          />
        }
      >
        <Routes />
      </Suspense>
    </MuxProvider>
  );
}

export default App;
